import React from 'react';
// import { Link } from 'react-router-dom';
import cx from 'classnames';

import { NavLink } from '..';
import styles from '../../Header/Header.scss';
import * as ROUTES from '../../../constants/routes';

// import socialFb from '../../../images/icons/icon_social_facebook.svg';
// import socialIm from '../../../images/icons/icon_social_instagram.svg';
// import socialTw from '../../../images/icons/icon_social_twitter.svg';

const NavBase = props => {
  return (
    <nav className={styles.nav}>
      <ul>
        <li>
          <NavLink to={ROUTES.HOME} {...props}>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13">
                <path d="M6.284 12.72H2.66V6.871H.47L7.756.305l7.284 6.566H12.85v5.85H9.226V8.341H6.284z" />
              </svg>
            </i>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to={ROUTES.GAMES} {...props}>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13">
                <g>
                  <path d="M7.094 8.904c.002-.768-.617-1.37-1.408-1.373-.79-.001-1.417.603-1.418 1.365 0 .76.632 1.37 1.417 1.366.785-.004 1.408-.604 1.41-1.358M14.2 6.157h-4.167c-.636.001-1.116.257-1.385.821-.072.151-.108.33-.114.498-.021.56.002 1.123-.034 1.682-.082 1.266-1.241 2.387-2.555 2.449-.887.042-1.777.021-2.665.027-.373.003-.746.004-1.119-.003a.312.312 0 0 1-.196-.077 6.623 6.623 0 0 1-1.853-3.51C-.471 4.963 1.259 1.845 4.234.588A7.261 7.261 0 0 1 7.331.004c3.094.101 5.672 2.061 6.558 4.817.136.425.205.87.312 1.336" />
                  <path d="M12.784 10.262V11.63h3.182v1.359h-4.603v-2.727h-.291c-.327 0-.654-.003-.98.002-.109.002-.154-.023-.152-.14.007-.402.003-.805.003-1.22.062-.003.11-.007.16-.007 1.9 0 3.8.001 5.7-.004.147 0 .18.043.178.175-.01.34-.011.68 0 1.019.005.149-.05.179-.193.178-.94-.005-1.88-.003-2.82-.003h-.184z" />
                </g>
              </svg>
            </i>
            Vikings Games
          </NavLink>
        </li>
        {props?.userInfo !== 'default' && (
          <li>
            <NavLink to={ROUTES.EVENTS} {...props}>
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14">
                  <path d="M10.397 7.98v3.284H7.113V7.981h3.284zM9.302.869h1.642v1.094h.82c.365 0 .685.137.958.41.274.274.41.593.41.958v9.302c0 .365-.136.684-.41.958-.273.273-.593.41-.957.41H1.368c-.365 0-.684-.137-.958-.41a1.312 1.312 0 0 1-.41-.958V3.33c0-.365.137-.684.41-.958.274-.273.593-.41.958-.41h.82V.868H3.83v1.094h5.472V.868zm2.463 11.764v-7.25H1.368v7.25h10.397z" />
                </svg>
              </i>
              Events
            </NavLink>
          </li>
        )}
        <li>
          <NavLink to={ROUTES.MAPS} {...props}>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16">
                <path d="M.66 13.72h10.19v1.436H.66V13.72zm3.624-8.755c0 .397.146.735.438 1.015.292.28.639.42 1.042.42.402 0 .747-.14 1.033-.42a1.37 1.37 0 0 0 .429-1.015c0-.397-.146-.741-.438-1.033a1.413 1.413 0 0 0-1.033-.438c-.397 0-.741.146-1.033.438a1.413 1.413 0 0 0-.438 1.033zm5.848 0c0 .607-.151 1.301-.455 2.084a13.796 13.796 0 0 1-1.085 2.153 25.042 25.042 0 0 1-1.296 1.891c-.35.467-.712.917-1.086 1.349l-.455.525-.455-.525a24.885 24.885 0 0 1-1.086-1.349 25.042 25.042 0 0 1-1.296-1.89 13.796 13.796 0 0 1-1.085-2.154c-.304-.783-.456-1.477-.456-2.084 0-.794.196-1.526.587-2.198a4.346 4.346 0 0 1 1.593-1.593A4.288 4.288 0 0 1 5.755.587c.794 0 1.526.196 2.198.587a4.346 4.346 0 0 1 1.593 1.593c.391.672.586 1.404.586 2.198z" />
              </svg>
            </i>
            Maps
          </NavLink>
        </li>
        {props?.userInfo !== 'default' && (
          <li>
            <NavLink to={ROUTES.ACCOUNT} {...props}>
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  fill="none"
                >
                  <g clipPath="url(#a)">
                    <path
                      fill="#ffffff"
                      d="M6.708 1.667a3.208 3.208 0 1 0 0 6.416 3.208 3.208 0 0 0 0-6.416ZM8.39 8.375h4.22l1.215 2.428-3.325 3.694-3.325-3.694L8.39 8.375Zm-1.241.292A4.066 4.066 0 0 0 6.417 11c0 .867.27 1.672.732 2.333H1.167v-1.166a3.5 3.5 0 0 1 3.5-3.5h2.482Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 .5h14v14H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Your Account
            </NavLink>
          </li>
        )}
        {props?.userInfo !== 'default' && (
          <li>
            <NavLink to={ROUTES.BENEFITS} {...props}>
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                >
                  <path d="M7.57598 2.84833C7.80012 2.72119 7.97586 2.52343 8.07577 2.2859C8.17568 2.04837 8.19414 1.78445 8.12827 1.53532C8.0624 1.2862 7.9159 1.06589 7.71165 0.908787C7.50739 0.751683 7.25687 0.666624 6.99918 0.666886C6.7415 0.667148 6.49115 0.752715 6.28721 0.910233C6.08327 1.06775 5.93722 1.28835 5.87186 1.53761C5.80649 1.78687 5.82549 2.05076 5.92588 2.28808C6.02628 2.52541 6.20242 2.72282 6.42682 2.8495L6.42098 2.86C6.0389 3.65742 5.50806 4.79958 4.68848 5.22833C4.01531 5.58008 3.04931 5.40333 2.33182 5.2715C2.32031 5.10835 2.2633 4.95169 2.16726 4.8193C2.07122 4.6869 1.94 4.58408 1.78848 4.52249C1.63697 4.4609 1.47122 4.443 1.31005 4.47084C1.14888 4.49868 0.998737 4.57114 0.87666 4.67999C0.754583 4.78884 0.665458 4.92972 0.619398 5.08666C0.573338 5.2436 0.572186 5.4103 0.616073 5.56786C0.65996 5.72542 0.74713 5.86753 0.867691 5.97805C0.988252 6.08858 1.13738 6.1631 1.29815 6.19317L3.01782 10.6323C3.14535 10.9614 3.36941 11.2443 3.66059 11.4437C3.95177 11.6432 4.29645 11.75 4.6494 11.75H9.35106C9.70401 11.75 10.0487 11.6432 10.3399 11.4437C10.6311 11.2443 10.8551 10.9614 10.9826 10.6323L12.7017 6.19317C12.8615 6.16343 13.0098 6.0898 13.1301 5.98052C13.2503 5.87124 13.3378 5.73062 13.3826 5.57443C13.4275 5.41824 13.428 5.25265 13.384 5.09621C13.34 4.93977 13.2534 4.79866 13.1337 4.6887C13.0141 4.57874 12.8662 4.50427 12.7066 4.47363C12.547 4.44299 12.382 4.4574 12.2302 4.51524C12.0783 4.57308 11.9456 4.67207 11.8468 4.80111C11.748 4.93014 11.6872 5.08414 11.671 5.24583C10.9366 5.34092 9.98981 5.46225 9.31198 5.10817C8.50873 4.68817 7.97031 3.62475 7.57598 2.84833Z" />
                </svg>
              </i>
              Benefits
            </NavLink>
          </li>
        )}
        <li>
          <NavLink to={ROUTES.FAQS} {...props}>
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
              >
                <path d="M12.3517 5.12297C12.1455 4.9075 11.9323 4.68547 11.8519 4.49023C11.7775 4.31141 11.7731 4.015 11.7688 3.72789C11.7605 3.19414 11.7518 2.5893 11.3313 2.16875C10.9107 1.7482 10.3059 1.73945 9.77211 1.73125C9.485 1.72687 9.18859 1.7225 9.00977 1.64812C8.81508 1.56773 8.5925 1.35445 8.37703 1.14828C7.99969 0.785703 7.57094 0.375 7 0.375C6.42906 0.375 6.00086 0.785703 5.62297 1.14828C5.4075 1.35445 5.18547 1.56773 4.99023 1.64812C4.8125 1.7225 4.515 1.72687 4.22789 1.73125C3.69414 1.73945 3.0893 1.7482 2.66875 2.16875C2.2482 2.5893 2.24219 3.19414 2.23125 3.72789C2.22687 4.015 2.2225 4.31141 2.14812 4.49023C2.06773 4.68492 1.85445 4.9075 1.64828 5.12297C1.2857 5.50031 0.875 5.92906 0.875 6.5C0.875 7.07094 1.2857 7.49914 1.64828 7.87703C1.85445 8.0925 2.06773 8.31453 2.14812 8.50977C2.2225 8.68859 2.22687 8.985 2.23125 9.27211C2.23945 9.80586 2.2482 10.4107 2.66875 10.8313C3.0893 11.2518 3.69414 11.2605 4.22789 11.2688C4.515 11.2731 4.81141 11.2775 4.99023 11.3519C5.18492 11.4323 5.4075 11.6455 5.62297 11.8517C6.00031 12.2143 6.42906 12.625 7 12.625C7.57094 12.625 7.99914 12.2143 8.37703 11.8517C8.5925 11.6455 8.81453 11.4323 9.00977 11.3519C9.18859 11.2775 9.485 11.2731 9.77211 11.2688C10.3059 11.2605 10.9107 11.2518 11.3313 10.8313C11.7518 10.4107 11.7605 9.80586 11.7688 9.27211C11.7731 8.985 11.7775 8.68859 11.8519 8.50977C11.9323 8.31508 12.1455 8.0925 12.3517 7.87703C12.7143 7.49969 13.125 7.07094 13.125 6.5C13.125 5.92906 12.7143 5.50086 12.3517 5.12297ZM7 10C6.87021 10 6.74333 9.96151 6.63541 9.8894C6.52749 9.81729 6.44337 9.7148 6.3937 9.59489C6.34403 9.47497 6.33104 9.34302 6.35636 9.21572C6.38168 9.08842 6.44418 8.97149 6.53596 8.87971C6.62774 8.78793 6.74467 8.72543 6.87197 8.70011C6.99927 8.67479 7.13122 8.68778 7.25114 8.73745C7.37105 8.78712 7.47354 8.87124 7.54565 8.97916C7.61776 9.08708 7.65625 9.21396 7.65625 9.34375C7.65625 9.5178 7.58711 9.68472 7.46404 9.80779C7.34097 9.93086 7.17405 10 7 10ZM7.4375 7.33562V7.375C7.4375 7.49103 7.39141 7.60231 7.30936 7.68436C7.22731 7.76641 7.11603 7.8125 7 7.8125C6.88397 7.8125 6.77269 7.76641 6.69064 7.68436C6.60859 7.60231 6.5625 7.49103 6.5625 7.375V6.9375C6.5625 6.82147 6.60859 6.71019 6.69064 6.62814C6.77269 6.54609 6.88397 6.5 7 6.5C7.72352 6.5 8.3125 6.00781 8.3125 5.40625C8.3125 4.80469 7.72352 4.3125 7 4.3125C6.27648 4.3125 5.6875 4.80469 5.6875 5.40625V5.625C5.6875 5.74103 5.64141 5.85231 5.55936 5.93436C5.47731 6.01641 5.36603 6.0625 5.25 6.0625C5.13397 6.0625 5.02269 6.01641 4.94064 5.93436C4.85859 5.85231 4.8125 5.74103 4.8125 5.625V5.40625C4.8125 4.3207 5.79359 3.4375 7 3.4375C8.20641 3.4375 9.1875 4.3207 9.1875 5.40625C9.1875 6.35672 8.435 7.15242 7.4375 7.33562Z" />
              </svg>
            </i>
            FAQS
          </NavLink>
        </li>
        {/* <li>
          <NavLink to={ROUTES.PREMIUMSEATINGSTAFF} {...props}>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
                <path d="M10.794 7.178c0 .188-.07.35-.208.482a.705.705 0 0 1-.507.2h-6.92L.397 10.655V.94c0-.189.067-.35.2-.482a.657.657 0 0 1 .482-.2h9c.2 0 .368.067.507.2a.644.644 0 0 1 .208.482v6.238zm2.761-4.159c.189 0 .35.067.483.2s.2.294.2.482v10.397l-2.762-2.761H3.84a.657.657 0 0 1-.483-.2.657.657 0 0 1-.2-.482V9.257h9V3.02h1.397z" />
              </svg>
            </i>
            Premium Seating Staff
          </NavLink>
        </li>
        {/* <li>
          <NavLink to={ROUTES.GALLERY} {...props}>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12">
                <g>
                  <path d="M12.802 1.925v8.094l-7.096 1.925V0l7.096 1.925M2.789 11.39V.553c.55.193 1.087.378 1.62.574.043.015.073.095.094.152.015.04.003.091.003.137 0 3.036-.002 6.072.006 9.108 0 .21-.063.293-.242.35-.491.16-.977.338-1.481.514M0 1.092c.53.185 1.04.36 1.548.546.044.016.075.095.096.152.015.04.003.091.003.137 0 2.697-.001 5.394.004 8.09 0 .19-.042.284-.223.341-.474.149-.94.324-1.428.496V1.092z" />
                </g>
              </svg>
            </i>
            Gallery
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink to={ROUTES.PREMIUMSEATINGSTAFF} {...props}>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
                <path d="M10.794 7.178c0 .188-.07.35-.208.482a.705.705 0 0 1-.507.2h-6.92L.397 10.655V.94c0-.189.067-.35.2-.482a.657.657 0 0 1 .482-.2h9c.2 0 .368.067.507.2a.644.644 0 0 1 .208.482v6.238zm2.761-4.159c.189 0 .35.067.483.2s.2.294.2.482v10.397l-2.762-2.761H3.84a.657.657 0 0 1-.483-.2.657.657 0 0 1-.2-.482V9.257h9V3.02h1.397z" />
              </svg>
            </i>
            Premium Seating Staff
          </NavLink>
        </li> */}
      </ul>
      <div
        className={cx(
          styles.header__top__content__social,
          styles.header__bottom__content__social__mobile,
        )}
      >
        {/* <Link to="">
          <img src={socialFb} alt="" />
        </Link>
        <Link to="">
          <img src={socialIm} alt="" />
        </Link>
        <Link to="">
          <img src={socialTw} alt="" />
        </Link> */}
      </div>
    </nav>
  );
};

export default NavBase;
